import React, { useEffect, useState } from 'react';

import LoaderComponent from '@components/LoaderComponent';
import { toastError } from '@components/Toast';

import BasicInfo from '@features/order/components/orderInfo/BasicInfo';
import OrderStyles from '@features/order/components/orderInfo/OrderStyles';
import AddStyleFromCurrentOrder from '@features/order/components/orderInfo/AddStyleFromCurrentOrder';

import { fetchEnumValues } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

const OrderInfoDetails = ({
	orderId,
	isDrafted,
	stylesCount,
	poItemIdentifier,
	productRefNumber,
	orderCancelInfo,
	getOrderCancelInfo,
	setOpenOrderDesignModal
}) => {
	const [loading] = useState(false);
	const [stylesUpdated, setStylesUpdated] = useState(false);
	const [pOSegmentationType, setPOSegmentationType] = useState([]);
	const [, setIsReadOnly] = useState(false);
	const [counts, setCounts] = useState({});
	const [activeCount, setActiveCount] = useState('totalStyle');
	const [, setSelectedCount] = useState('');
	const [newlyAddedStyles, setNewlyAddedStyles] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				await fetchEnumValues('info.nitex.app.rfq.POSegmentationType', setPOSegmentationType);
			} catch {}
		})();
	}, []);

	const fetchCounts = async () => {
		try {
			const data = await ApiClient.GET(`${BASE_URL}/order/quotes/${orderId}/status-count`, '', true);
			setSelectedCount(`(Total no of style - ${data?.data?.totalNoOfStyle})`);
			setCounts(data.data);
		} catch (err) {
			toastError(err.response.data.message);
		}
	};

	useEffect(() => {
		const search = window.location.search;
		const params = new URLSearchParams(search);
		const selectedRoute = params.get('routeFrom');
		if (selectedRoute === 'ORDER_CANCEL') {
			setIsReadOnly(true);
		}
		fetchCounts();
	}, [orderId]);

	const onAddSuccess = () => {
		setStylesUpdated((prev) => !prev);
		setNewlyAddedStyles([]);
	};

	const onRemoveStyles = (productId) => {
		setNewlyAddedStyles(newlyAddedStyles.filter((item) => item.productId !== productId));
	};

	const handleCountClick = (value) => {
		setActiveCount(value);
		switch (value) {
			case 'piCreated':
				setSelectedCount(`(PI created - ${counts?.piCreated})`);
				break;
			case 'piPending':
				setSelectedCount(`(PI pending - ${counts?.piPending})`);
				break;
			case 'scCreated':
				setSelectedCount(`(SC created - ${counts?.scCreated})`);
				break;
			case 'scPending':
				setSelectedCount(`(SC pending - ${counts?.scPending})`);
				break;
			case 'tnaCreated':
				setSelectedCount(`(TNA created - ${counts?.tnaCreated})`);
				break;
			case 'tnaPending':
				setSelectedCount(`(TNA pending - ${counts?.tnaPending})`);
				break;
			default:
				setSelectedCount(`(Total no of style - ${counts?.totalNoOfStyle})`);
				break;
		}
	};

	const addNewStyle = async (product) => {
		// setOrderStyles((prevState) => [...prevState, ...product]);
		let isExist = newlyAddedStyles.find((item) => item.productId === product.productId);
		if (isExist === undefined) {
			await setNewlyAddedStyles((prevState) => [...prevState, ...product]);
		}
	};

	const renderTotalCounts = () => {
		return (
			<div className="total-style-details">
				<div
					className={`total-style cursor-pointer ${activeCount === 'totalStyle' ? 'active' : ''}`}
					onClick={() => handleCountClick('totalStyle')}
				>
					<p className="regular-14 gray_dark_02 mb-1">Total no of style</p>
					<p className="semibold-14">{stylesCount || 0}</p>
				</div>
				<div className="pi-sc-info">
					<div className="item cursor-pointer">
						<div
							className={`created ${activeCount === 'piCreated' ? 'active' : ''}`}
							onClick={() => handleCountClick('piCreated')}
						>
							<p className="regular-14 gray_dark_02 mb-1">PI created</p>
							<p className="semibold-14">{counts?.piCreated}</p>
						</div>
						<div
							className={`pending ${activeCount === 'piPending' ? 'active' : ''}`}
							onClick={() => handleCountClick('piPending')}
						>
							<p className="regular-14 gray_dark_02 mb-1">PI pending</p>
							<p className="semibold-14">{counts?.piPending}</p>
						</div>
					</div>
					<div className="item cursor-pointer">
						<div
							className={`created ${activeCount === 'scCreated' ? 'active' : ''}`}
							onClick={() => handleCountClick('scCreated')}
						>
							<p className="regular-14 gray_dark_02 mb-1">SC created</p>
							<p className="semibold-14">{counts?.scCreated}</p>
						</div>
						<div
							className={`pending ${activeCount === 'scPending' ? 'active' : ''}`}
							onClick={() => handleCountClick('scPending')}
						>
							<p className="regular-14 gray_dark_02 mb-1">SC pending</p>
							<p className="semibold-14">{counts?.scPending}</p>
						</div>
					</div>
					<div className="item cursor-pointer">
						<div
							className={`created ${activeCount === 'tnaCreated' ? 'active' : ''}`}
							onClick={() => handleCountClick('tnaCreated')}
						>
							<p className="regular-14 gray_dark_02 mb-1">TNA created</p>
							<p className="semibold-14">{counts?.tnaCreated}</p>
						</div>
						<div
							className={`pending ${activeCount === 'tnaPending' ? 'active' : ''}`}
							onClick={() => handleCountClick('tnaPending')}
						>
							<p className="regular-14 gray_dark_02 mb-1">TNA pending</p>
							<p className="semibold-14">{counts?.tnaPending}</p>
						</div>
					</div>
				</div>
			</div>
		);
	};

	return (
		<LoaderComponent loading={loading}>
			<div className="body-content">
				<div className="create-order-container p-0 basic-order-section">
					<div className="common-accordion">
						<div className="order-single-accordion">
							<BasicInfo orderId={orderId} />
							{!isDrafted && renderTotalCounts()}
							<OrderStyles
								key={stylesUpdated}
								orderId={orderId}
								isDrafted={isDrafted}
								hideStatusType={activeCount}
								poItemIdentifier={poItemIdentifier}
								productRefNumber={productRefNumber}
								addNewStyle={addNewStyle}
								orderCancelInfo={orderCancelInfo}
								getOrderCancelInfo={getOrderCancelInfo}
								pOSegmentationType={pOSegmentationType}
								stylesCount={stylesCount}
								setOpenOrderDesignModal={setOpenOrderDesignModal}
							/>

							{newlyAddedStyles.length > 0 && (
								<AddStyleFromCurrentOrder
									orderId={orderId}
									newlyAddedStyle={newlyAddedStyles}
									onAddSuccess={onAddSuccess}
									onRemoveStyles={onRemoveStyles}
									getProjectDetails={() => false}
									pOSegmentationType={pOSegmentationType}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</LoaderComponent>
	);
};

export default OrderInfoDetails;
